export default __webpack_public_path__ + "static/media/recipientPhoto.ae67bd1e.jpg";